<div class="header-buttons pull-right row mr-0 ml-2">
    <button class="col" kendoButton [primary]="true" routerLinkActive="active" routerLink="/data-migration"
        [icon]="'add'" *ngIf="isAdminCheck">
        <span>Data Migration</span>
    </button>
    <button class="col" kendoButton [primary]="true" routerLinkActive="active" routerLink="/award-information-entry"
        [icon]="'add'" *ngIf="isAdminCheck">
        <span>Add New Award</span>
    </button>
    <button class="col" kendoButton [primary]="true" routerLinkActive="active" (click)="addUserRouting()" 
        [icon]="'add'" *ngIf="isAdminCheck">
        <span>Add User</span>
    </button>
</div>
<h3>Award Search</h3>
<form [formGroup]="dashBoardForm">
    <div class="card card-customize">
        <div class="card-block">
            <fieldset>
                <legend>Filter:</legend>
                <div class="row  mt-3">
                    <div class="col-md-3">
                        <kendo-textbox-container floatingLabel="Country">
                            <kendo-multiselect [data]="countryList" [textField]="'name'" [valueField]="'name'"
                                [valuePrimitive]="true" [filterable]="true" (filterChange)="handleCountryFilter($event)"
                                formControlName="country" (valueChange)="countrySelectionChange($event)"
                                (removeTag)="onRemoveCountry($event)">
                            </kendo-multiselect>
                        </kendo-textbox-container>
                    </div>
                    <div class="col-md-3">
                        <kendo-textbox-container floatingLabel="Award Status">
                            <kendo-combobox [data]="agreementStatusList" [textField]="'statusName'"
                                [valueField]="'agreementStatusId'" [valuePrimitive]="true" [filterable]="true"
                                (filterChange)="handleAwardStatus($event)" formControlName="status"
                                (selectionChange)="awardStatusSelectionChange($event)">
                            </kendo-combobox>
                        </kendo-textbox-container>
                    </div>
                    <div class="col-md-3">
                        <kendo-textbox-container floatingLabel="Award Maintainer">
                            <kendo-combobox [data]="allUsersList" [textField]="'displayName'" [valueField]="'id'"
                                [valuePrimitive]="true" [filterable]="true"
                                (filterChange)="handleEGPAFAwardManager($event)" formControlName="awardMaintainer"
                                (selectionChange)="awardManagerSelectionChange($event)">
                            </kendo-combobox>
                        </kendo-textbox-container>
                    </div>
                    <div class="col-md-3">
                        <kendo-textbox-container floatingLabel="Donor Agency">
                            <kendo-combobox [data]="donorAgencyList" [textField]="'agencyName'" [valueField]="'donorId'"
                                [valuePrimitive]="true" [filterable]="true" (filterChange)="handleDonorAgency($event)"
                                (selectionChange)="donorAgencySelectionChange($event)" formControlName="donorAgency">
                            </kendo-combobox>
                        </kendo-textbox-container>
                    </div>
                </div>

                <div class="row mt-3 align-items-end">
                    <div class="col-md-3">
                        <kendo-textbox-container floatingLabel="Technical Areas">
                            <kendo-multiselect [data]="technicalAreaList" [textField]="'description'"
                                [valueField]="'description'" [valuePrimitive]="true" [filterable]="true"
                                (filterChange)="handleTechnicalAreas($event)" formControlName="technicalArea"
                                (valueChange)="technicalAreaSelectionChange($event)"
                                (removeTag)="onRemoveTechnicalArea($event)">
                            </kendo-multiselect>
                        </kendo-textbox-container>
                    </div>
                    <div class="col-md-3">
                        <kendo-textbox-container floatingLabel="Title">
                            <input kendoTextBox value="" (keyup)="titleChange($event)" formControlName="title"
                                (keydown.enter)="prevent($event)" />
                        </kendo-textbox-container>
                    </div>
                    <div class="col-md-3">
                        <kendo-textbox-container floatingLabel="Award Nick Name">
                            <input kendoTextBox value="" (keyup)="awardNickNameChange($event)"
                                formControlName="awardNickName" (keydown.enter)="prevent($event)" />
                        </kendo-textbox-container>
                    </div>
                    <div class="col-md-3">
                        <kendo-textbox-container floatingLabel="Award Number">
                            <input kendoTextBox value="" (keyup)="awardNumberChange($event)"
                                formControlName="awardNumber" (keydown.enter)="prevent($event)" />
                        </kendo-textbox-container>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-right">
                        <button kendoButton [primary]="true" [icon]="'close'" (click)="onClearAll()">
                            <span>Clear All</span>
                        </button>
                    </div>
                </div>
            </fieldset>

            <div class="row">
                <div class="col-md-12 mt-4">
                    <div class="table-parent-container">
                        <kendo-grid [data]="gridData" [columnMenu]="{sort: true, columnChooser: false}" [pageSize]="pageSize" [skip]="skip"
                            (pageChange)="pageChange($event)" (dataStateChange)="dataStateChange($event)" [sort]="sort"
                            (sortChange)="sortChange($event)" (filterChange)="filterChange($event)" [pageable]="{
                        buttonCount: buttonCount,
                        info: info,
                        type: typedg,
                        pageSizes: pageSizes,
                        previousNext: previousNext
                      }" [resizable]="true">
                            <kendo-grid-column field="View" title="View" [width]="130">
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <a class="hyperlink" routerLinkActive="active"
                                        routerLink="/award-information-entry"
                                        [queryParams]="{'id': dataItem.AgreementId}">View Agreement </a>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column title="Award Number" field="EGPAFAwardNumber" [width]="150">
                                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                    {{column.title}}
                                </ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span [title]="dataItem.EGPAFAwardNumber">
                                       <span> {{dataItem.EGPAFAwardNumber}}</span>
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column title="Title" field="Title" [width]="200">
                                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                    {{column.title}}
                                </ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span [title]="dataItem.Title">
                                        <span> {{dataItem.Title}}</span>
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column title="Award Nick Name" field="NickName" [width]="200">
                                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                    {{column.title}}
                                </ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span [title]="dataItem.NickName">
                                        <span> {{dataItem.NickName}}</span>
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column title="Donor Agency" field="AgencyName" [width]="150">
                                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                    {{column.title}}
                                </ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span [title]="dataItem.AgencyName">
                                        <span> {{dataItem.AgencyName}}</span>
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column title="Technical Areas" field="TechnicalAreas" [width]="150">
                                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                    {{column.title}}
                                </ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span [title]="dataItem.TechnicalAreas">
                                        <span>{{dataItem.TechnicalAreas}} </span>
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column title="Award Maintainer" field="AwardManager" [width]="150">
                                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                    {{column.title}}
                                </ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span [title]="dataItem.AwardManager">
                                        <span>{{dataItem.AwardManager}} </span>
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column title="Status" field="StatusName" [width]="100">
                                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                    {{column.title}}
                                </ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span [title]="dataItem.StatusName">
                                        <span>{{dataItem.StatusName}} </span>
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column field="Countries" [width]="150">
                                <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                    {{column.field}}
                                </ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span [title]="dataItem.CountryNames">
                                        <span>{{dataItem.CountryNames}} </span>
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                        </kendo-grid>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>